<template>
<div id="content">
<!-- ページ内ヘッダ -->
	<!-- <div>
		<p>【申込までの流れ】</p>
		<ul class="pankuzu">
			<li>一覧表示</li>
			<li>申込理由/活動日程選択</li>
			<li>内容確認</li>
			<li class="selected">申込完了</li>
		</ul>
	</div> -->
	<div class="inner">
		<div id="mosikomi" class="content-blk">
			<p class="Regist_title">申込が完了しました</p>
			<div class="inner">
				<p>ボランティアの参加申込が完了しました。<br>青森市ボランティアセンターで確認のち、登録されたメールアドレス宛に申請許可のメールを送信します。<br>申し込み状況は［マイページ］－［申込履歴］からも確認ができます。<br>メールアドレスを登録されていない方は、［申込履歴］をご活用ください。<br><router-link to="/mypage" class="page-link"><fa icon="history" class="icon" />申込履歴へ</router-link><br><span class="error" style="font-size: 1.6rem;">※ブラウザの戻るボタンは使用しないでください。</span></p>
			</div>
			<div class="center">
				<router-link to="/"><button class="btn_on">検索画面へ戻る</button></router-link>
			</div>
		</div>
	</div>
</div>
</template>

<script>
import { inject } from 'vue';
import router from '../router';
export default {
	name: 'KatsudoMosikomiConfirm',
	components: {
	},
	setup() {
		const { katudom } = inject('kmosikomi');
		return {
			katudom,
		};
	},
	data() {
		return {
			// katudom: {},
		};
	},
	methods: {
		onSubmit() {
			// 登録処理
			// （追記）
			router.push({ path: '/katudo-mosikomi/registered'});
		},
	},
}
</script>

<style scoped>
.page-link {
	text-decoration: underline;
}
.page-link:hover {
	background: #e0e0e0;
}
</style>